import React from 'react';
import { CircleCheckIcon, SquareCheckIcon } from '@cx-web/components/primitives/icons';

import type { SupportedRepubName } from '~/repub-config';

export type AuthConfig = {
  featureList: {
    title: string;
  }[];
  featureListIcon: React.ReactNode;
  header: (t: Function) => string;
  logoAlt: string;
  logoSrc: (resourcesUrl: string) => string;
  privacyPolicyUrl: (repubPath: string) => string;
  showAgreeTermsAsCheckbox: boolean;
  showMarketingConsent: boolean;
  showSocialLogin: boolean;
  tagline: (t: Function) => string;
  termsAndConditionsUrl: (repubPath: string) => string;
};

export const AUTH_CONFIGS = {
  WS: {
    featureList: [
      { title: 'AI Powered Projections' },
      { title: 'AI Powered Probabilities' },
      { title: 'Easy Visualised Trends' },
      { title: '...and more' },
    ],
    header: (_t: Function) => 'More Intelligent, More Profitable, More Often',
    logoAlt: 'WhoScored',
    logoSrc: (resourcesUrl: string) => `${resourcesUrl}/assets/img/ws-logo-white.png`,
    tagline: (_t: Function) =>
      'With over 41 million data points every week on WhoScored now powered by provably accurate AI projections, WhoScored+ helps you win more, more often with your soccer betting.',
    showAgreeTermsAsCheckbox: true,
    showMarketingConsent: true,
    termsAndConditionsUrl: (repubPath: string) => `${repubPath}/termsofuse`,
    privacyPolicyUrl: (repubPath: string) => `${repubPath}/privacy`,
    showSocialLogin: false,
    featureListIcon: <SquareCheckIcon />,
  },
  US: {
    featureList: [
      { title: 'Positive Expected Value Bets' },
      { title: 'AI Probabilities for each bet' },
      { title: 'Public Betting Splits' },
      { title: 'Trends and insights' },
      { title: 'Custom Betslip' },
    ],
    logoSrc: (resourcesUrl: string) => `${resourcesUrl}/assets/img/oc-pro-logo.svg`,
    logoAlt: 'Oddschecker',
    header: (t: Function) => t('CX_OCPLUS_AUTH_HEADER'),
    tagline: (t: Function) => t('CX_OCPLUS_AUTH_TAGLINE'),
    featureListIcon: <CircleCheckIcon />,
    showAgreeTermsAsCheckbox: false,
    showMarketingConsent: false,
    termsAndConditionsUrl: (repubPath: string) => `${repubPath}/terms-and-conditions`,
    privacyPolicyUrl: (repubPath: string) => `${repubPath}/privacy`,
    showSocialLogin: true,
  },
  OC: {
    featureList: [
      { title: 'Positive Expected Value Bets' },
      { title: 'AI Probabilities for each bet' },
      { title: 'Public Betting Splits' },
      { title: 'Trends and insights' },
      { title: 'Custom Betslip' },
    ],
    logoSrc: (resourcesUrl: string) => `${resourcesUrl}/assets/img/oc-pro-logo.svg`,
    logoAlt: 'Oddschecker',
    header: (t: Function) => t('CX_OCPLUS_AUTH_HEADER'),
    tagline: (t: Function) => t('CX_OCPLUS_AUTH_TAGLINE'),
    featureListIcon: <CircleCheckIcon />,
    showAgreeTermsAsCheckbox: true,
    showMarketingConsent: true,
    termsAndConditionsUrl: (repubPath: string) => `${repubPath}/myoddschecker/terms-and-conditions`,
    privacyPolicyUrl: (repubPath: string) => `${repubPath}/myoddschecker/privacy`,
    showSocialLogin: true,
  },
  GZ: {
    featureList: [
      { title: 'Positive Expected Value Bets' },
      { title: 'AI Probabilities for each bet' },
      { title: 'Public Betting Splits' },
      { title: 'Trends and insights' },
      { title: 'Custom Betslip' },
    ],
    logoSrc: (resourcesUrl: string) => `${resourcesUrl}/assets/img/oc-pro-logo.svg`,
    logoAlt: 'Oddschecker',
    header: (t: Function) => t('CX_OCPLUS_AUTH_HEADER'),
    tagline: (t: Function) => t('CX_OCPLUS_AUTH_TAGLINE'),
    featureListIcon: <CircleCheckIcon />,
    showAgreeTermsAsCheckbox: true,
    showMarketingConsent: true,
    termsAndConditionsUrl: (repubPath: string) => `${repubPath}/myoddschecker/terms-and-conditions`,
    privacyPolicyUrl: (repubPath: string) => `${repubPath}/myoddschecker/privacy`,
    showSocialLogin: false,
  },
} satisfies Record<SupportedRepubName, AuthConfig>;
